import { render, staticRenderFns } from "./LabelsTable.vue?vue&type=template&id=806eaec2&scoped=true&"
import script from "./LabelsTable.vue?vue&type=script&lang=js&"
export * from "./LabelsTable.vue?vue&type=script&lang=js&"
import style0 from "./LabelsTable.vue?vue&type=style&index=0&id=806eaec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806eaec2",
  null
  
)

export default component.exports